const UploadFileIcon = (props: any) => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.375 8.67285L6.25 10.9229L8.875 7.54785L12.25 12.0479H1.75L4.375 8.67285ZM13.75 12.7979V2.29785C13.75 1.46535 13.075 0.797852 12.25 0.797852H1.75C1.35218 0.797852 0.970644 0.955887 0.68934 1.23719C0.408035 1.5185 0.25 1.90003 0.25 2.29785V12.7979C0.25 13.1957 0.408035 13.5772 0.68934 13.8585C0.970644 14.1398 1.35218 14.2979 1.75 14.2979H12.25C12.6478 14.2979 13.0294 14.1398 13.3107 13.8585C13.592 13.5772 13.75 13.1957 13.75 12.7979Z"
        fill="#8B90A5"
      />
    </svg>
  );
};

export default UploadFileIcon;
